import { service } from '@ember/service';
import type { ValidatorMap } from 'ember-changeset/types';
import type IntlService from 'ember-intl/services/intl';
import FileAttachmentDisplayer from 'parog-web/components/file-attachment-displayer';
import Content from 'parog-web/components/file-uploaded/edition-form/content';
import JournalEventBasedComponent from 'parog-web/components/forc/abstract/journal-event-based-component';
import Provider from 'parog-web/components/forc/provider';
import JournalEventRetrievalStrategies from 'parog-web/components/forc/utils/journal-event-retrieval-strategies';
import FileUploadedJournalEvent from 'parog-web/models/file-uploaded-journal-event';

export default class FileUploadedEditionFormComponent extends JournalEventBasedComponent {
  static override forcDisplayName = 'Document envoyé';
  static override fullComponentId = 'file-uploaded/edition-form';
  static override journalEventClass = FileUploadedJournalEvent;

  @service declare intl: IntlService;

  override journalEventProperties = [
    'occurredAt',
    'fileSubType',
    'title',
    'body'
  ];
  override retrieveJournalEvent =
    JournalEventRetrievalStrategies.sourceJournalEvent;

  override get validations(): ValidatorMap {
    return this.journalEventClass.validations(this.intl);
  }

  <template>
    <Provider @forcComponent={{this}}>
      <:content as |Form|>
        <Content @form={{Form}} />
        {{#if this.retrievedJournalEvent.fileAttachments}}
          {{#each
            this.retrievedJournalEvent.fileAttachments
            as |fileAttachment|
          }}
            <FileAttachmentDisplayer
              @shouldDisplayDownloadLink={{true}}
              @fileAttachment={{fileAttachment}}
              @alternativeText='fichier envoyé'
            />
          {{/each}}
        {{/if}}
      </:content>
    </Provider>
  </template>
}
